module.exports = __webpack_public_path__ + "img/g856.bb6762ec.png";